"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var react_1 = require("@emotion/react");

var StyledColumn = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: flex;\n\t-ms-flex-preferred-size: 0;\n\t-ms-flex-positive: 1;\n\tflex-basis: auto;\n\tflex-shrink: 1;\n\tflex-grow: 0;\n\t", "\n"])), function (props) {
  var gutter = props.gutter,
      style = props.css,
      styles = props.styles,
      align = props.align;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\talign-items: ", ";\n\t\t\tpadding: ", "px;\n\t\t\t", ";\n\t\t\t", ";\n\t\t"])), align, gutter, styles, style && style.styles);
});
var Cell = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\t", "\n"])), function (props) {
  var style = props.css;
  return (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t", ";\n\t\t"])), style && style.styles);
});

var Column = function Column(props) {
  var style = props.style;
  var _props$align = props.align,
      align = _props$align === void 0 ? "center" : _props$align;

  switch (align) {
    case "top":
      align = "flex-start";
      break;

    case "bottom":
      align = "flex-end";
      break;

    default:
      break;
  } // This functional component is not following our normal functional component standard
  // of defining the props as parameters to the functional component. The reason
  // for this is a number of the props are optional. Referencing the optional props
  // as keys to the props object makes the code less verbose below.


  var children = props.children,
      gutter = props.gutter;

  var _ref = (0, frontend_theme_1.useTheme)(),
      theme = _ref.theme;

  var breakpoints = ["xs", "sm", "md", "lg", "xl"];
  var defaultColumnSpan = 12;
  var columnSpan = defaultColumnSpan;
  var styles = breakpoints.reduce(function (styles, val) {
    var bpStyle = "@media only screen and (min-width: ".concat(theme.breakpoints[val], "){");
    var span = props[val] ? props[val] : defaultColumnSpan;
    columnSpan = span !== 12 ? span : columnSpan;
    var offset = props["offset-".concat(val)];

    if (columnSpan) {
      var width = "".concat(Math.round(columnSpan / defaultColumnSpan * 10e7) / 10e5, "%");
      bpStyle += " width: ".concat(width, "; ");
    }

    if (offset) {
      var offsetWidth = "".concat(Math.round(offset / defaultColumnSpan * 10e7) / 10e5, "%");
      bpStyle += " margin-left: ".concat(offsetWidth, "; ");
    }

    if (!span && !offset) {
      var _width = "".concat(Math.round(1 / defaultColumnSpan * 10e7) / 10e5, "%");

      bpStyle += " width: ".concat(_width, "; ");
    }

    styles += bpStyle + "}; ";
    return styles;
  }, "");
  return (0, jsx_runtime_1.jsx)(StyledColumn, {
    gutter: gutter,
    styles: styles,
    children: (0, jsx_runtime_1.jsx)(Cell, {
      css: style,
      children: children
    })
  });
};

exports.Column = Column;